import apiInstance from './api';

const realationGroupApi = apiInstance.injectEndpoints({
  endpoints: (build) => ({
    getAllRelationGroups: build.query({
      query: (params) => ({
        url: '/article_relation_groups',
        params,
      }),
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['RelationGroups'],
    }),
    getRelationGroupById: build.query({
      query: ({ groupId }) => ({
        url: `/article_relation_groups/${groupId}`,
        method: 'GET',
      }),
      providesTags: ['RelationGroups'],
    }),
    getRelationGroupsByOffer: build.query({
      query: ({ offerId }) => ({
        url: `/article_relation_groups/offer/${offerId}`,
        method: 'GET',
      }),
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['RelationGroups'],
    }),
    createRelationGroup: build.mutation({
      query: ({ body }) => ({
        url: '/article_relation_groups',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['RelationGroups'],
    }),
    editRelationGroup: build.mutation({
      query: ({ id, body }) => ({
        url: `/article_relation_groups/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['RelationGroups'],
    }),
    deleteArticleRelationGroup: build.mutation({
      query: ({ id }) => ({
        url: `/article_relation_groups/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RelationGroups'],
    }),
    getRelationGroupList: build.query({
      query: (params) => ({
        url: '/article_relation_groups',
        params,
      }),
      providesTags: ['RelationGroups'],
    }),
    getAllRelationGroupsInfinite: build.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages, lastPageParam) =>
          lastPage['hydra:member'].length > 0 ? lastPageParam + 1 : undefined,
      },
      query({ queryArg, pageParam }) {
        const { name } = queryArg ?? {};
        return {
          url: '/article_relation_groups',
          params: {
            page: pageParam,
            itemsPerPage: 20,
            ...(name && { name }),
          },
        };
      },
      providesTags: ['RelationGroups'],
    }),
  }),
  overrideExisting: true,
});
export default realationGroupApi;
